import classNames from "classnames";
import React, { useContext, useState } from "react";

import { RiCloseFill } from "react-icons/ri";
import { FormattedMessage, useIntl } from "react-intl";
import { GlobalContext } from "../../globals/globalContext.jsx";
import { CartTopProfileSection } from "../../modules/cart/CartTop/CartTop.jsx";
import Button from "../button/ButtonController.jsx";
import ChangePassword from "../change-password/ChangePasswordController.jsx";
import Contact from "../contact/Contact.jsx";
import PastDeliveries from "../customer-deliveries/PastDeliveries.jsx";
import UpcomingDeliveries from "../customer-deliveries/UpcomingDeliveries.jsx";
import DataProtection from "../data-protection/DataProtection.jsx";
import Deposit from "../deposit/Deposit.jsx";
import Email from "../email/Email.jsx";
import Impressum from "../impressum/Impressum.jsx";
import ProvidedLoginController, {
  Context as LoginContext,
} from "../login/LoginController.jsx";
import Logo from "../logo/Logo.jsx";
import Notifications from "../notifications/Notifications.jsx";
import Payment from "../payment/PaymentController.jsx";
import Profile from "../profile/ProfileController.jsx";
import Rule from "../rule/Rule.jsx";
import { Tab, Tabs } from "../settings-tabs/SettingsTabsController.jsx";
import Terms from "../terms/Terms.jsx";
import "./styles.styl";

export default function Settings(props) {
  const {
    bioCertification,
    colorPrimary,
    colorSecondary,
    companyAddress,
    companyEmail,
    companyName,
    conditionsPage,
    delivery_address,
    gmbhName,
    homePage,
    logoSmallUrl,
    phoneNumber,
    privacyPage,
    subscription,
    taxDetails,
    webhost,
  } = useContext(GlobalContext);

  const { setIsAuthenticated } = useContext(LoginContext);
  const {
    activeTabIndex,
    addInvoicePaymentMethod,
    className,
    delivery,
    isAuthenticated,
    isDeliveryAddress,
    is_shipping,
    onBackClick,
    onCloseClick,
    onLogoutClick,
    onProfileSuccess,
    onTabChange,
    onTabSuccess,
    pickup_address,
    shouldRegister,
    timeframe,
    addSepaPaymentMethod,
    paymentProvider,
    visitedFromCart,
    isStaff,
  } = props;

  const [showLogin, setShowLogin] = useState(false);

  const { customer = {}, deliveries = {} } = subscription || {};
  const tabActive = activeTabIndex !== undefined;

  const is_autogenerated = customer?.email_is_autogenerated;

  const displayed = !shouldRegister && isAuthenticated;
  const onLoginClick = () => setShowLogin(!showLogin);
  const onCloseOrBack =
    (tabActive && visitedFromCart) || !tabActive ? onCloseClick : onBackClick;
  const intl = useIntl();

  const openSettingsOrTab = (tabIndex, fromFooter = false) => {
    closeSettingsAndconfigureActiveTab(tabIndex, fromFooter).then(() => {
      onTopClick();
    });
  };

  const handleClose = (callback) => {
    document.body.classList.remove("settings-active");
    callback();
  };

  return (
    <div className={classNames("settings", className)}>
      <div className="settings__inner">
        <div className="settings__head">
          <div className="cartHeader__subscription-home settings__mobile_logo">
            <Logo
              logoSmallUrl={logoSmallUrl}
              className="cartHeader__logo"
              onClick={openSettingsOrTab}
            />
            <p
              className={classNames("cartHeader__company", {
                cartHeader__company_long: companyName.length > 10,
              })}
            >
              {companyName}
            </p>
          </div>
          <CartTopProfileSection
            subscription={subscription}
            openSettingsOrTab={() => handleClose(onCloseClick)}
          />
        </div>

        {!tabActive && (
          <div
            className="settings-tabs__head setting_wrapper"
            onClick={() => handleClose(onCloseOrBack)}
          >
            <div className="settings__close settingClose">
              <RiCloseFill size={25} color={"white"} />
            </div>
            <div className="setting_title settings-tabs__head">
              <span>{intl.formatMessage({ id: "setting" })}</span>
            </div>
          </div>
        )}
        <Tabs
          onChange={onTabChange}
          activeIndex={activeTabIndex}
          onCloseOrBack={onCloseOrBack}
          visitedFromCart={visitedFromCart}
        >
          <Tab name={intl.formatMessage({ id: "subscription" })} icon="cube">
            <Rule
              subscription={subscription}
              companyName={companyName}
              logoSmallUrl={logoSmallUrl}
              displayed={displayed}
              onSuccess={onTabSuccess}
              visitedFromCart={visitedFromCart}
              onCloseClick={onCloseClick}
              delivery={delivery}
            />
          </Tab>
          <Tab
            name={intl.formatMessage({ id: "notifications" })}
            icon="bell"
            displayed={!is_autogenerated}
          >
            <Notifications
              subscription={subscription}
              webhost={webhost}
              onSuccess={onTabSuccess}
            />
          </Tab>
          <Tab
            name={intl.formatMessage({ id: "upcomingDeliveries" })}
            icon="shopping_cart"
            displayed={isStaff ? true : displayed}
          >
            <UpcomingDeliveries
              subscription={subscription}
              displayed={true}
              delivery={delivery}
              onCloseClick={onCloseClick}
              isAuthenticated={isAuthenticated}
              isStaff={isStaff}
              onLoginClick={onLoginClick}
            />
          </Tab>
          <Tab
            name={intl.formatMessage({ id: "pastDeliveries" })}
            icon="invoice-done"
            displayed={isStaff ? true : displayed}
          >
            <PastDeliveries
              subscription={subscription}
              displayed={isStaff ? true : displayed}
              delivery={delivery}
              onCloseClick={onCloseClick}
            />
          </Tab>
          <Tab
            name={intl.formatMessage({ id: "deposit" })}
            icon="pfand_logo"
            displayed={displayed}
          >
            <Deposit customer={customer} displayed={displayed} />
          </Tab>
          <Tab
            name={intl.formatMessage({ id: "addresses" })}
            icon="home"
            displayed={displayed}
          >
            <Profile
              slim
              onSuccess={onProfileSuccess}
              customer={customer}
              is_shipping={is_shipping}
              isDeliveryAddress={isDeliveryAddress}
              delivery_address={delivery_address}
              pickup_address={pickup_address}
              timeframe={timeframe}
              companyEmail={companyEmail}
              displayed={displayed}
              setIsAuthenticated={setIsAuthenticated}
            />
          </Tab>
          <Tab
            name={intl.formatMessage({ id: "paymentMethod" })}
            icon="card"
            displayed={displayed}
          >
            <Payment
              slim
              onSuccess={onTabSuccess}
              addInvoicePaymentMethod={addInvoicePaymentMethod}
              addSepaPaymentMethod={addSepaPaymentMethod}
              paymentProvider={paymentProvider}
              displayed={displayed}
              companyAddress={companyAddress}
            />
          </Tab>
          <Tab name="Email" icon="mail" displayed={displayed}>
            <Email
              webhost={webhost}
              onSuccess={onTabSuccess}
              displayed={displayed}
            />
          </Tab>
          <Tab
            name={intl.formatMessage({ id: "changePsw" })}
            icon="lock"
            displayed={displayed}
          >
            <ChangePassword onSuccess={onTabSuccess} displayed={displayed} />
          </Tab>
          <Tab name={intl.formatMessage({ id: "contact" })} icon="comment">
            <Contact
              phoneNumber={phoneNumber}
              companyEmail={companyEmail}
              logoSmallUrl={logoSmallUrl}
            />
          </Tab>
          <Tab name="Impressum" icon="info">
            <Impressum
              gmbhName={gmbhName}
              companyEmail={companyEmail}
              logoSmallUrl={logoSmallUrl}
              companyAddress={companyAddress}
              bioCertification={bioCertification}
              taxDetails={taxDetails}
              homePage={homePage}
            />
          </Tab>
          <Tab
            name={intl.formatMessage({ id: "termsAndConditionsHc" })}
            icon="legal"
          >
            <Terms
              logoSmallUrl={logoSmallUrl}
              conditionsPage={conditionsPage}
              gmbhName={gmbhName}
            />
          </Tab>
          <Tab name={intl.formatMessage({ id: "dataPrivacy" })} icon="shield">
            <DataProtection
              logoSmallUrl={logoSmallUrl}
              privacyPage={privacyPage}
              gmbhName={gmbhName}
            />
          </Tab>
        </Tabs>
        {!tabActive ? (
          <div className="settings__foot">
            {!isAuthenticated ? (
              is_autogenerated ? (
                <p className="settings__is_autogenerated_text">
                  <FormattedMessage id="unlockMoreSettings" />
                </p>
              ) : (
                <Button onClick={onLoginClick} transparent>
                  Login
                </Button>
              )
            ) : !shouldRegister ? (
              <Button onClick={onLogoutClick} transparent>
                Logout
              </Button>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
      {showLogin && (
        <ProvidedLoginController
          active
          onClose={props.onClose}
          onLoginClick={onLoginClick}
          {...props}
        />
      )}
    </div>
  );
}
